import { useQuery } from '@tanstack/react-query';
import { fetchWorkOrderByCustomerId } from "./endpoints";
export const useWorkOrderByCustomerId = (customerId) => {
    var _a, _b, _c;
    const { data: workOrderByCustomerId, isLoading, isFetching, isError, error, } = useQuery({
        queryKey: ['workorder-by-customer-id', customerId],
        queryFn: () => fetchWorkOrderByCustomerId(customerId),
        enabled: !!customerId,
    });
    const workOrderByCustomerIdErrorMessage = ((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data.message) || ((_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.title) || '';
    return {
        workOrderByCustomerId,
        isLoading,
        isFetching,
        isError,
        workOrderByCustomerIdErrorMessage,
    };
};
